<template src="./FormSidebar.html"></template>
<style src="./FormSidebar.scss" lang="scss"></style>
<script>
export default {
    name: 'FormSidebar',

    computed: {
        form () {
            return this.$store.state.form
        },

        strings () {
            return this.$store.state.strings
        },

        condizioniContrattualiUrl() {
            return this.$store.state.form.cgfUrl
        },

        notaInfUrl() {
            return this.$store.state.form.notaInfUrl
        },

        schedaProdottoPdfUrl() {
            return this.$store.state.form.schedaProdottoPdfUrl
        }
    },

    methods: {
        sendBillToggle () {
            this.$store.commit('sendBillDisplay', 'visible')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/FormSidebar/FormSidebar.vue